<template>
  <v-form ref="form">
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.firstName"
        :label="adminText('adminAll.first_name_7e568a', 'First name')"
        :validator="vs.form.firstName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.lastName"
        :label="adminText('adminAll.last_name_adec36', 'Last name')"
        :validator="vs.form.lastName"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.email"
        :label="adminText('adminAll.email_84add5', 'Email')"
        :validator="vs.form.email"
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.eventQuota"
        :validator="vs.form.eventQuota"
        :error-messages="{ minValue: adminText('adminAll.minimum_quota_is_1_4e7296', 'Minimum quota is 1')}"
        :label="adminText('adminAll.event_quota_142b3e', 'Event Quota')"
        type="number"
      />
    </v-flex>
  </v-form>
</template>

<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'

export default {
  mixins: [AdminContext, AdminAllMessages],
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    reset: {
      type: Boolean,
      default: false,
    },
    initialValues: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form(val) {
      this.$emit('values', val)
    },
    reset(val) {
      if (val) {
        this.form = { eventQuota: 1 }
        this.vs.$reset()
        this.$emit('update:reset', !val)
      }
    },
  },
}
</script>

<style>

</style>
